import { useState, useEffect } from "react";
import { useApp } from "../context/AppContext";

const DEFAULT_VARS = [
  { key: "{H1}", desc: "H1 заголовок сторінки" },
  { key: "{parent_H1}", desc: "H1 батьківської категорії" },
  { key: "{filter_value}", desc: "Значення обраного фільтру" },
  { key: "{filter_value_2}", desc: "Значення другого фільтру" },
  { key: "{page_name}", desc: "Назва сторінки (категорії)" },
  { key: "{brand}", desc: "Назва бренду/магазину" },
  { key: "{city}", desc: "Місто (напр. Київ)" },
  { key: "{domain}", desc: "Домен сайту" },
];

const DEFAULT_TYPES = [
  { id: "product", name: "Картка товару", title: "{H1} - купити {H1} в {city} та Україні з доставкою в інтернет-магазині {brand}", description: "{H1} купити в Україні. ✔️ Знижки ✔️ Висока якість ✔️ Виробник ✔️ Без посередників. ✅ Швидка доставка.", h1: "{H1}", urlExample: "" },
  { id: "category", name: "Категорія", title: "{H1} - купити {H1} в {city} та Україні, ціна в інтернет-магазині {brand}", description: "{H1} - купуйте в {city} та по Україні за вигідними цінами. Великий вибір, швидка доставка та гарантія якості.", h1: "{H1}", urlExample: "" },
  { id: "filter_1", name: "Фільтр (1 параметр)", title: "{page_name} {filter_value} - купити в {city} та Україні, ціна в інтернет-магазині {brand}", description: "{page_name} {filter_value} - купуйте {parent_H1} в {city} та по Україні за вигідними цінами. Великий вибір, швидка доставка.", h1: "{page_name} {filter_value}", urlExample: "" },
  { id: "filter_2", name: "Фільтр (2 параметри)", title: "{page_name} {filter_value}, {filter_value_2} - купити в {city} та Україні, ціна в інтернет-магазині {brand}", description: "{page_name} {filter_value}, {filter_value_2} - купуйте {parent_H1} в {city} та по Україні за вигідними цінами.", h1: "{page_name} {filter_value}, {filter_value_2}", urlExample: "" },
  { id: "blog", name: "Стаття/блог", title: "{H1} | {brand}", description: "{H1} - читайте корисну статтю на сайті {brand}. Поради експертів, рекомендації та детальна інформація.", h1: "{H1}", urlExample: "" },
  { id: "service", name: "Послуга", title: "{H1} в {city} - ціна, запис | {brand}", description: "{H1} в {city}. ✔️ Досвідчені спеціалісти ✔️ Сучасне обладнання ✔️ Доступні ціни. Запишіться онлайн!", h1: "{H1}", urlExample: "" },
];

export default function MetaFormulaView() {
  const { proj, activeId, apiFetch, dark, t, card, inp, btnP, btnG, btnSm, stitle, flash } = useApp();
  const [types, setTypes] = useState(DEFAULT_TYPES);
  const [brand, setBrand] = useState(proj?.name || "");
  const [city, setCity] = useState("Київ");
  const [editIdx, setEditIdx] = useState(null);
  const [saving, setSaving] = useState(false);
  const [exceptions, setExceptions] = useState([]);
  const [showAddType, setShowAddType] = useState(false);
  const [newType, setNewType] = useState({ id: "", name: "", title: "", description: "", h1: "", urlExample: "" });
  const token = localStorage.getItem("metago_token");

  // Load saved data
  useEffect(() => {
    if (!activeId) return;
    apiFetch(`/api/projects/${activeId}/onboarding`).then(r => r.json())
      .then(d => {
        if (d?.metaFormulas) {
          if (d.metaFormulas.types) setTypes(d.metaFormulas.types);
          if (d.metaFormulas.brand) setBrand(d.metaFormulas.brand);
          if (d.metaFormulas.city) setCity(d.metaFormulas.city);
          if (d.metaFormulas.exceptions) setExceptions(d.metaFormulas.exceptions);
        }
      }).catch(() => {});
  }, [activeId, apiFetch]);

  const save = async (data) => {
    setSaving(true);
    try {
      const existing = await apiFetch(`/api/projects/${activeId}/onboarding`).then(r => r.json());
      const current = existing && typeof existing === "object" ? existing : {};
      current.metaFormulas = data || { types, brand, city, exceptions };
      await apiFetch(`/api/projects/${activeId}/onboarding`, { method: "PUT", body: JSON.stringify({ data: current }) });
    } catch {}
    setSaving(false);
  };

  const updateType = (idx, field, value) => {
    const next = types.map((tp, i) => i === idx ? { ...tp, [field]: value } : tp);
    setTypes(next);
  };

  const removeType = (idx) => {
    const next = types.filter((_, i) => i !== idx);
    setTypes(next);
    save({ types: next, brand, city, exceptions });
  };

  const addType = () => {
    if (!newType.name || !newType.id) return;
    const next = [...types, { ...newType }];
    setTypes(next);
    setNewType({ id: "", name: "", title: "", description: "", h1: "", urlExample: "" });
    setShowAddType(false);
    save({ types: next, brand, city, exceptions });
  };

  const addException = () => {
    setExceptions(prev => [...prev, { page: "", url: "", filter: "", h1: "", title: "", description: "" }]);
  };

  const updateException = (idx, field, value) => {
    setExceptions(prev => prev.map((e, i) => i === idx ? { ...e, [field]: value } : e));
  };

  const removeException = (idx) => {
    setExceptions(prev => prev.filter((_, i) => i !== idx));
  };

  // Preview formula with sample data per type
  const previewSamples = {
    product: { H1: "Подушка Premium silk №1504 Creamy Luxe", parent_H1: "Подушки", page_name: "Подушки", filter_value: "", filter_value_2: "" },
    category: { H1: "Ковдри", parent_H1: "Текстиль", page_name: "Ковдри", filter_value: "", filter_value_2: "" },
    filter_1: { H1: "Ковдри 110*140", parent_H1: "Ковдри", page_name: "Ковдри", filter_value: "110*140", filter_value_2: "" },
    filter_2: { H1: "Ковдри 110*140, бавовна", parent_H1: "Ковдри", page_name: "Ковдри", filter_value: "110*140", filter_value_2: "бавовна" },
    blog: { H1: "Як обрати подушку для сну", parent_H1: "Блог", page_name: "Блог", filter_value: "", filter_value_2: "" },
    service: { H1: "Консультація ортопеда", parent_H1: "Послуги", page_name: "Послуги", filter_value: "", filter_value_2: "" },
  };

  const preview = (formula, typeId) => {
    const s = previewSamples[typeId] || previewSamples.product;
    return formula
      .replace(/\{H1\}/g, s.H1)
      .replace(/\{parent_H1\}/g, s.parent_H1)
      .replace(/\{page_name\}/g, s.page_name)
      .replace(/\{filter_value\}/g, s.filter_value)
      .replace(/\{filter_value_2\}/g, s.filter_value_2)
      .replace(/\{brand\}/g, brand || proj?.name || "Brand")
      .replace(/\{city\}/g, city || "Київ")
      .replace(/\{domain\}/g, proj?.domain || "example.com");
  };

  // Generate PDF
  const generatePDF = () => {
    const domain = proj?.domain || "";
    const html = `<!DOCTYPE html><html><head><meta charset="UTF-8">
<style>
  body { font-family: 'Segoe UI', Arial, sans-serif; max-width: 800px; margin: 0 auto; padding: 40px 30px; color: #1a1a2e; font-size: 13px; line-height: 1.6; }
  h1 { font-size: 22px; color: #1a1a2e; border-bottom: 3px solid #6366f1; padding-bottom: 12px; margin-bottom: 8px; }
  h2 { font-size: 16px; color: #6366f1; margin-top: 32px; margin-bottom: 12px; padding-bottom: 6px; border-bottom: 1px solid #e5e7eb; }
  h3 { font-size: 14px; color: #333; margin-top: 20px; margin-bottom: 8px; }
  .subtitle { color: #666; font-size: 12px; margin-bottom: 24px; }
  .meta-label { font-weight: 700; color: #6366f1; font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 4px; }
  .formula-box { background: #f8f9fb; border: 1px solid #e5e7eb; border-radius: 8px; padding: 12px 16px; margin-bottom: 8px; font-family: monospace; font-size: 12px; word-break: break-all; }
  .preview-box { background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 8px; padding: 12px 16px; margin-bottom: 16px; font-size: 12px; color: #166534; }
  .var-tag { background: #ede9fe; color: #6366f1; padding: 2px 6px; border-radius: 4px; font-family: monospace; font-size: 11px; font-weight: 600; }
  table { width: 100%; border-collapse: collapse; margin: 12px 0; }
  th { background: #f8f9fb; text-align: left; padding: 8px 12px; font-size: 11px; font-weight: 700; color: #666; text-transform: uppercase; border-bottom: 2px solid #e5e7eb; }
  td { padding: 8px 12px; border-bottom: 1px solid #f3f4f6; font-size: 12px; vertical-align: top; }
  .note { background: #fff7ed; border: 1px solid #fed7aa; border-radius: 8px; padding: 12px 16px; margin: 16px 0; font-size: 12px; }
  .note strong { color: #c2410c; }
  .section-num { color: #6366f1; font-weight: 700; }
  .page-break { page-break-before: always; }
  .footer { text-align: center; color: #999; font-size: 10px; margin-top: 40px; padding-top: 16px; border-top: 1px solid #e5e7eb; }
</style></head><body>

<h1>Технічне завдання на генерацію метаданих</h1>
<div class="subtitle">Проект: <strong>${proj?.name || ""}</strong> | Домен: ${domain} | Дата: ${new Date().toLocaleDateString("uk-UA")}</div>

<h2><span class="section-num">1.</span> Мета завдання</h2>
<p>Розробити універсальні формули генерації метаданих (Title, Description, H1) для автоматичного створення SEO-оптимізованих метаданих з урахуванням типу сторінки, структури URL та ключових слів.</p>

<h2><span class="section-num">2.</span> Основні цілі впровадження</h2>
<ul>
  <li>Стандартизація створення метаданих</li>
  <li>Підвищення релевантності сторінок пошуковим запитам</li>
  <li>Мінімізація людського фактору</li>
  <li>Автоматизація SEO-оптимізації</li>
</ul>

<h2><span class="section-num">3.</span> Очікуваний результат</h2>
<ul>
  <li>100% автоматична генерація метаданих</li>
  <li>Метадані відповідають тематиці сторінки</li>
  <li>Підвищення CTR у пошуковій видачі</li>
  <li>Зростання позицій у Google</li>
</ul>

<h2><span class="section-num">4.</span> Важливі технічні умови</h2>
<div class="note">
  <strong>⚠️</strong> Формули генерації застосовуються тільки для <strong>української</strong> версії сайту.<br>
  <strong>⚠️</strong> Якщо H1 сторінки змінюється, він повинен автоматично змінюватися і в метаданих.
</div>

<h2><span class="section-num">5.</span> Змінні для формул</h2>
<table>
  <tr><th>Змінна</th><th>Опис</th></tr>
  ${DEFAULT_VARS.map(v => `<tr><td><span class="var-tag">${v.key}</span></td><td>${v.desc}</td></tr>`).join("")}
  <tr><td><span class="var-tag">{brand}</span></td><td>= "${brand}"</td></tr>
  <tr><td><span class="var-tag">{city}</span></td><td>= "${city}"</td></tr>
</table>

<h2><span class="section-num">6.</span> Типи сторінок</h2>
<p>Метадані генеруються для ${types.length} типів сторінок:</p>
<ol>
  ${types.map(tp => `<li><strong>${tp.name}</strong></li>`).join("")}
</ol>

${types.map((tp, i) => `
<h2 class="${i > 0 ? "page-break" : ""}"><span class="section-num">${7 + i}.</span> Формула: ${tp.name}</h2>
<table>
  <tr><th style="width:120px">Елемент</th><th>Значення</th></tr>
  <tr><td>Тип сторінки</td><td><strong>${tp.name}</strong></td></tr>
  <tr><td>ID</td><td><code>${tp.id}</code></td></tr>
  ${tp.urlExample ? `<tr><td>URL приклад</td><td>${tp.urlExample}</td></tr>` : ""}
</table>

<h3>Формула H1</h3>
<div class="formula-box">${tp.h1}</div>

<h3>Формула Title</h3>
<div class="formula-box">${tp.title}</div>

<h3>Формула Description</h3>
<div class="formula-box">${tp.description}</div>

<h3>Приклад згенерованих метаданих</h3>
<div class="preview-box">
  <div><strong>H1:</strong> ${preview(tp.h1, tp.id)}</div>
  <div><strong>Title:</strong> ${preview(tp.title, tp.id)}</div>
  <div><strong>Description:</strong> ${preview(tp.description, tp.id)}</div>
</div>

<h3>Джерела даних</h3>
<table>
  <tr><th>Змінна</th><th>Джерело</th></tr>
  ${(tp.h1 + tp.title + tp.description).match(/\{[^}]+\}/g)?.filter((v, i, a) => a.indexOf(v) === i).map(v => {
    const d = DEFAULT_VARS.find(dv => dv.key === v);
    return `<tr><td><span class="var-tag">${v}</span></td><td>${v === "{brand}" ? brand : v === "{city}" ? city : d ? d.desc : "Налаштовується"}</td></tr>`;
  }).join("") || "<tr><td colspan='2'>—</td></tr>"}
</table>
`).join("")}

${exceptions.length > 0 ? `
<h2 class="page-break"><span class="section-num">${7 + types.length}.</span> Виключення</h2>
<p>Для наступних сторінок використовуються індивідуальні формули:</p>
<table>
  <tr><th>Сторінка</th><th>URL</th><th>H1</th><th>Title</th><th>Description</th></tr>
  ${exceptions.map(e => `<tr><td>${e.page}</td><td style="font-size:10px;word-break:break-all">${e.url}</td><td style="font-size:11px">${e.h1}</td><td style="font-size:11px">${e.title}</td><td style="font-size:11px">${e.description}</td></tr>`).join("")}
</table>` : ""}

<div class="footer">
  Документ згенеровано автоматично — Spalah SEO Platform | ${new Date().toLocaleDateString("uk-UA")}
</div>
</body></html>`;

    const win = window.open("", "_blank");
    win.document.write(html);
    win.document.close();
    setTimeout(() => win.print(), 500);
  };

  if (!proj) return null;

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
        <h2 style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>ТЗ Мета-формули</h2>
        {saving && <span style={{ fontSize: 10, color: "#6366f1" }}>зберігаю...</span>}
        <div style={{ marginLeft: "auto", display: "flex", gap: 8 }}>
          <button onClick={() => save({ types, brand, city, exceptions })} style={{ ...btnG, fontSize: 12 }}>Зберегти</button>
          <button onClick={generatePDF} style={{ ...btnP, fontSize: 12 }}>PDF</button>
        </div>
      </div>

      {/* Global settings */}
      <div style={{ ...card, display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
        <div>
          <label style={{ fontSize: 10, color: t.textMuted, fontWeight: 600, display: "block", marginBottom: 4 }}>Бренд / Назва магазину</label>
          <input value={brand} onChange={e => setBrand(e.target.value)} style={{ ...inp, width: 200, fontSize: 12 }} placeholder="Мірсон" />
        </div>
        <div>
          <label style={{ fontSize: 10, color: t.textMuted, fontWeight: 600, display: "block", marginBottom: 4 }}>Місто</label>
          <input value={city} onChange={e => setCity(e.target.value)} style={{ ...inp, width: 120, fontSize: 12 }} placeholder="Київ" />
        </div>
        <div style={{ marginLeft: "auto" }}>
          <label style={{ fontSize: 10, color: t.textMuted, fontWeight: 600, display: "block", marginBottom: 4 }}>Змінні</label>
          <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
            {DEFAULT_VARS.map(v => (
              <span key={v.key} style={{ fontSize: 9, padding: "2px 6px", borderRadius: 4, background: "rgba(99,102,241,0.08)", color: "#6366f1", fontWeight: 600, cursor: "help" }} title={v.desc}>{v.key}</span>
            ))}
          </div>
        </div>
      </div>

      {/* Page types */}
      {types.map((tp, idx) => {
        const isEdit = editIdx === idx;
        return (
          <div key={idx} style={{ ...card, padding: 0, marginBottom: 8, overflow: "hidden" }}>
            <div onClick={() => setEditIdx(isEdit ? null : idx)} style={{
              display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", cursor: "pointer",
              background: isEdit ? (dark ? "rgba(99,102,241,0.06)" : "rgba(99,102,241,0.03)") : "transparent",
            }}>
              <span style={{ fontSize: 11, color: isEdit ? "#6366f1" : t.textMuted, transform: isEdit ? "rotate(90deg)" : "none", transition: "transform .2s" }}>▶</span>
              <span style={{ fontSize: 14, fontWeight: 700 }}>{tp.name}</span>
              <span style={{ fontSize: 10, color: t.textMuted, padding: "2px 6px", borderRadius: 4, background: dark ? "#252535" : "#f3f4f6" }}>{tp.id}</span>
              <span style={{ fontSize: 10, color: t.textMuted, marginLeft: "auto" }}>{(tp.title || "").length} сим. title</span>
              <button onClick={e => { e.stopPropagation(); removeType(idx); }} style={{ ...btnSm, color: "#ef4444", fontSize: 10 }}>x</button>
            </div>

            {isEdit && (
              <div style={{ padding: "0 16px 16px" }}>
                <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
                  <div style={{ flex: 1 }}>
                    <label style={{ fontSize: 10, color: t.textMuted, fontWeight: 600 }}>ID типу</label>
                    <input value={tp.id} onChange={e => updateType(idx, "id", e.target.value)} style={{ ...inp, fontSize: 11 }} />
                  </div>
                  <div style={{ flex: 2 }}>
                    <label style={{ fontSize: 10, color: t.textMuted, fontWeight: 600 }}>Назва типу</label>
                    <input value={tp.name} onChange={e => updateType(idx, "name", e.target.value)} style={{ ...inp, fontSize: 11 }} />
                  </div>
                  <div style={{ flex: 2 }}>
                    <label style={{ fontSize: 10, color: t.textMuted, fontWeight: 600 }}>URL приклад</label>
                    <input value={tp.urlExample || ""} onChange={e => updateType(idx, "urlExample", e.target.value)} style={{ ...inp, fontSize: 11 }} placeholder="https://..." />
                  </div>
                </div>

                {[["H1", "h1"], ["Title", "title"], ["Description", "description"]].map(([label, field]) => (
                  <div key={field} style={{ marginBottom: 8 }}>
                    <label style={{ fontSize: 10, color: "#6366f1", fontWeight: 700, textTransform: "uppercase" }}>{label}</label>
                    <textarea value={tp[field]} onChange={e => updateType(idx, field, e.target.value)} rows={field === "description" ? 3 : 1}
                      style={{ ...inp, fontSize: 11, marginTop: 2, resize: "vertical", fontFamily: "monospace" }} />
                    <div style={{ fontSize: 10, color: t.textMuted, marginTop: 2, padding: "4px 8px", borderRadius: 6, background: dark ? "rgba(16,185,129,0.04)" : "rgba(16,185,129,0.03)" }}>
                      {preview(tp[field], tp.id)}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}

      {/* Add type */}
      {showAddType ? (
        <div style={{ ...card, padding: 16 }}>
          <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
            <input value={newType.id} onChange={e => setNewType(p => ({ ...p, id: e.target.value }))} placeholder="ID (напр. landing)" style={{ ...inp, fontSize: 11, flex: 1 }} />
            <input value={newType.name} onChange={e => setNewType(p => ({ ...p, name: e.target.value }))} placeholder="Назва типу" style={{ ...inp, fontSize: 11, flex: 2 }} />
          </div>
          {[["H1", "h1"], ["Title", "title"], ["Description", "description"]].map(([label, field]) => (
            <div key={field} style={{ marginBottom: 6 }}>
              <label style={{ fontSize: 10, color: "#6366f1", fontWeight: 700 }}>{label}</label>
              <input value={newType[field]} onChange={e => setNewType(p => ({ ...p, [field]: e.target.value }))} style={{ ...inp, fontSize: 11, fontFamily: "monospace" }} placeholder={`Формула ${label}...`} />
            </div>
          ))}
          <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
            <button onClick={addType} disabled={!newType.id || !newType.name} style={btnP}>Додати</button>
            <button onClick={() => setShowAddType(false)} style={btnG}>Скасувати</button>
          </div>
        </div>
      ) : (
        <button onClick={() => setShowAddType(true)} style={{ ...btnG, width: "100%", justifyContent: "center", padding: "10px 0", marginBottom: 14 }}>+ Додати тип сторінки</button>
      )}

      {/* Exceptions */}
      <div style={{ ...card, padding: 0, overflow: "hidden" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", borderBottom: `1px solid ${t.border}` }}>
          <span style={{ fontSize: 14, fontWeight: 700 }}>Виключення</span>
          <span style={{ fontSize: 11, color: t.textMuted }}>{exceptions.length} шт</span>
          <button onClick={addException} style={{ ...btnSm, marginLeft: "auto", fontSize: 10 }}>+ Додати</button>
        </div>
        {exceptions.map((exc, idx) => (
          <div key={idx} style={{ padding: "10px 16px", borderBottom: `1px solid ${dark ? "#1e1e2c" : "#f7f7f7"}` }}>
            <div style={{ display: "flex", gap: 6, marginBottom: 6, alignItems: "center" }}>
              <input value={exc.page} onChange={e => updateException(idx, "page", e.target.value)} placeholder="Назва сторінки" style={{ ...inp, fontSize: 10, flex: 1, padding: "4px 8px" }} />
              <input value={exc.url} onChange={e => updateException(idx, "url", e.target.value)} placeholder="URL" style={{ ...inp, fontSize: 10, flex: 2, padding: "4px 8px" }} />
              <button onClick={() => removeException(idx)} style={{ ...btnSm, color: "#ef4444", fontSize: 9 }}>x</button>
            </div>
            <div style={{ display: "flex", gap: 6 }}>
              <input value={exc.h1} onChange={e => updateException(idx, "h1", e.target.value)} placeholder="H1" style={{ ...inp, fontSize: 10, flex: 1, padding: "4px 8px" }} />
              <input value={exc.title} onChange={e => updateException(idx, "title", e.target.value)} placeholder="Title" style={{ ...inp, fontSize: 10, flex: 1, padding: "4px 8px" }} />
              <input value={exc.description} onChange={e => updateException(idx, "description", e.target.value)} placeholder="Description" style={{ ...inp, fontSize: 10, flex: 1, padding: "4px 8px" }} />
            </div>
          </div>
        ))}
        {exceptions.length === 0 && <div style={{ padding: "12px 16px", fontSize: 11, color: t.textMuted }}>Немає виключень</div>}
      </div>
    </div>
  );
}
